import { authorizedRequest, logout } from './account';
import { responseError } from './errors';

export const authorizedJsonRequest = (url, options) => authorizedRequest(url, options)
  .then((result) => {
    if (result && typeof result.json === 'function') {
      const status = result.status;
      const ok = typeof result.ok === 'boolean'
        ? result.ok
        : status >= 200 && status < 300;

      if (status === 204) {
        return { data: null, ok, status };
      }

      return result.json()
        .then(data => ({ data, ok, status }))
        .catch(() => ({ data: null, ok, status }));
    }

    if (String(result).includes('TypeError')) {
      return { data: result, ok: false, status: 0 };
    }

    // authorizedRequest already deserializes HTTP 200 responses.
    return { data: result, ok: true, status: 200 };
  })
  .catch(error => ({ data: error, ok: false, status: 0 }));

export const handleWebResourceFailure = (dispatch, result) => {
  if (result.status === 401) {
    dispatch(logout());
    return;
  }

  if (result.status === 0) {
    dispatch(responseError('Problems with server'));
    return;
  }

  const data = result.data || {};
  dispatch(responseError(data.message || data.error || 'Request failed'));
};

export const listData = (data) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};
